<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-27 16:38:26
 * @LastEditors: may.li
 * @LastEditTime: 2023-05-31 14:47:58
-->
<template>
	<div>
		<div class="thumb-wrap">
			<img :src="$publicData.ossUrl+item" alt="" v-for="(item,index) in thumbList" :key="index">
		</div>
	</div>
</template>
<script>
export default {
	data(){
		return{
			
		}
	},
	props: {
		thumbList: {
			type: Array,
			default: function () {
				return [];
			}
		}
	},
	created(){

	},
	methods: {
		
	}
}
</script>
<style scoped>
	.thumb-wrap img{
		width: 80px;
		margin-right: 10px;
		margin-top: 10px;
	}
</style>